import { render, staticRenderFns } from "./RegistrationRequestsList.vue?vue&type=template&id=0d785716"
import script from "./RegistrationRequestsList.vue?vue&type=script&lang=js"
export * from "./RegistrationRequestsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports